import React, { useContext, useRef, useEffect, useState } from 'react';
import { withStyles, Grid } from '@material-ui/core';
// import Menu from "../../asset/img/btn_menu_nor.png";
import Menu from '../../asset/img/footer_btn_menu.svg';
import MenuDisabled from '../../asset/img/btn_menu_dis.png';
// import MenuSelected from "../../asset/img/btn_menu_sel.png";
import MenuClose from '../../asset/img/btn_menu_close_nor.png';
// import MenuCloseSelected from "../../asset/img/btn_menu_close_sel.png";
import Carousel from '../carousel/Carousel';

import DataContext from '../data/DataContext';
import InputContext from '../data/InputContext';
// import Send from "../../asset/img/btn_send_nor.png";
import SendNotFocused from '../../asset/img/footer_btn_send.svg';
import SendFocused from '../../asset/img/footer_btn_send_focused.svg';

// import SendSelected from "../../asset/img/btn_send_sel.png";
import SendDisabled from '../../asset/img/btn_send_dis.png';
import CancelBtn from '../../asset/img/footer_btn_cancel.svg';
import TextareaAutosize from 'react-autosize-textarea';

import HomeIcon from '../../asset/img/ic_undo.png';
import MenuGear from '../../asset/img/Icon_menu_repair.svg'; // "../../asset/img/footer_ico_gear.svg"
import MenuCalendar from '../../asset/img/Icon_menu_reservation.svg'; //"../../asset/img/footer_ico_calendar.svg"
import MenuCenter from '../../asset/img/Icon_menu_location.svg'; //"../../asset/img/footer_ico_center.svg"
import MenuConsulting from '../../asset/img/Icon_menu_purchasing_expert.svg'; //"../../asset/img/footer_ico_consulting.svg"
import MenuGuide from '../../asset/img/Icon_menu_guidebook.svg';
import MenuStory from '../../asset/img/Icon_menu_story.svg';
import MenuEvent from '../../asset/img/Icon_menu_event.svg'; //"../../asset/img/footer_ico_event.svg"
import MenuLogin from '../../asset/img/Icon_menu_login.svg';
import MenuPolicy from '../../asset/img/Icon_menu_policy.svg';
import MenuInstall from '../../asset/img/Icon_menu_move_installation.svg'; //"../../asset/img/footer_ico_install.svg"
import MenuRental from '../../asset/img/Icon_menu_recommend_rental.svg'; //"../../asset/img/footer_ico_rental.svg"
import MenuSearch from '../../asset/img/Icon_menu_search.svg'; //"../../asset/img/footer_ico_search.svg"
import MenuShop from '../../asset/img/Icon_menu_bestshop.svg'; //"../../asset/img/footer_ico_shop.svg"
import MenuWash from '../../asset/img/Icon_menu_cleaning_products.svg'; //"../../asset/img/footer_ico_wash.svg"
import MenuLifestyle from '../../asset/img/footer_ico_lifestyle.svg';
import MenuRecomProd from '../../asset/img/Icon_menu_recommend_products.svg';
import MenuTables from '../../asset/img/Icon_menu_consumables.svg'; //"../../asset/img/footer_ico_tables.svg"

import { chatAIAutocomplete } from '../data/DataLoader';

const styles = (theme) => ({
  root: {
    width: '100%',
    // maxHeight: "1.5rem",
    minHeight: '54px',
    zIndex: 100,
    // position: "fixed",
    bottom: '0px',
    background: theme.color.app_bar_material_background,
  },
  row: {
    minHeight: '54px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#FFF',
    // padding: "0 12px 0 0"
  },
  rowDisable: {
    width: '100%',
    minHeight: 'inherit',
    position: 'fixed',
    bottom: '0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: theme.color.input.disabled,
    color: theme.color.primary_text_default_dark,
    fontSize: theme.font.size15, // "15px",
    fontWeight: 600,
  },
  formContainer: {
    flexGrow: 1,
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '6px',
    border: 'solid 1px #ddd',
    margin: '0 12px 0 0',
    padding: '0 0 0 16px',
    height: '46px',
    // borderLeft: `1px solid ${theme.color.list_divider}`,
  },
  form: {
    flexGrow: 1,
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  input: {
    width: '100%',
    // maxHeight: "46px",
    border: 'none',
    background: 'none',
    flex: 1,
    // margin: "0px 10px",
    resize: 'none',
    fontSize: theme.font.size14,
    color: theme.color.input.text,
    // height: "46px",
    fontWeight: 'normal',
    '&::placeholder': {
      color: theme.color.input.placeholder,
    },
    '&:focus::-webkit-input-placeholder': {
      color: 'transparent',
    },
    fontFamily:
      'Noto Sans CJK KR, Noto Sans, RobotoDraft, Roboto, San Francisco, Apple SD Gothic Neo, Helvetica Neue, sans-serif',
    // outline: 'none',
    textDecoration: 'none',
  },
  button: {
    // minWidth: "40px",
    width: '56px',
    height: '56px',
    padding: '0px',
    // "&:active": {
    //   color: theme.palette.secondary.main,
    // },
    overflow: 'hidden',
    backgroundColor: 'transparent',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    border: 'none',
    // outline: '0 none',
  },
  send: {
    minWidth: '24px',
    height: '24px',
    backgroundColor: 'transparent',
    // backgroundColor: "linear-gradient(to bottom right, #1e8728, #00829b, #1377d1)",
    // borderRadius: "25px 0px 0px 25px",
    border: '0px',
    // outline: '0 none',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '0px',
    margin: '0 12px 0 0',
  },
  sendImage: {
    minWidth: '24px',
    height: '24px',
    backgroundSize: 'contain',
    backgroundColor: '0xfff',
    // todo : selected image가 없어서 임시주석, 추후 추가
    // "&:active": {
    //   backgroundImage: `url(${SendSelected})`,
    // },
    // margin: "0px 8px",
  },
  sendImageNotFocused: {
    backgroundImage: `url(${SendNotFocused})`,
  },
  sendImageFocused: {
    backgroundImage: `url(${SendFocused})`,
  },
  sendImageDisabled: {
    backgroundImage: `url(${SendDisabled})`,
  },

  cancel: {
    minWidth: '20px',
    height: '20px',
    backgroundColor: 'transparent',
    border: '0px',
    // outline: '0 none',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '0px',
    margin: '0 12px 0 0',
  },
  cancelImage: {
    minWidth: '20px',
    height: '20px',
    backgroundSize: 'contain',
    backgroundImage: `url(${CancelBtn})`,
    backgroundColor: '0xfff',
  },

  test: {
    width: '46px',
    height: '42px',
    background: 'linear-gradient(to bottom right, #6ad17d, #5680e9)',
    border: '0px',
    borderRadius: '25px 0px 0px 25px',
    // outline: '0 none',
    right: '0px',
    position: 'absolute',
    transition: 'all .5s ease-in-out',
  },
  recording: {
    width: 'calc(100vw - 64px)',
    transition: 'all .5s ease-in-out',
  },
  menuButton: {
    height: '24px',
    margin: '8px',
    backgroundSize: '24px',
    backgroundImage: `url(${Menu})`,
    // todo - select 되었을때 button image가 없어 임시 주석, 추후 추가할 것
    // "&:active": {
    //   backgroundImage: `url(${MenuSelected})`,
    // },
  },
  menuClose: {
    height: '32px',
    margin: '8px',
    backgroundSize: '32px',
    backgroundImage: `url(${MenuClose})`,
    // "&:active": {
    //   backgroundImage: `url(${MenuCloseSelected})`,
    // },
  },
  menuDisabled: {
    backgroundImage: `url(${MenuDisabled})`,
  },
  menu: {
    // minHeight: "13.375em", // "214px",
    width: '100%',
    minWidth: '100%',
    // height: "fit-content",
    background: theme.color.menu.background,
    padding: '10px 20px',
    margin: '0px',
    overflow: 'auto',
    maxHeight: 'calc(100% - 60px)',
  },
  menus: {
    width: '100%',
    height: '100%',
    minHeight: '2rem', // "32px",
    borderRadius: '32px', // "16px",
    // fontSize: theme.font.size14,
    fontSize: '16px',
    fontWeight: 'bold',
    // outline: '0 none',
    lineHeight: '1',
    padding: '0px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    wordBreak: 'break-word',
  },
  menuHome: {
    background: '#ffffff',
    border: 'solid 1px #7f7f7f',
    color: theme.color.menu.home,
    fontWeight: 'bold',
    fontSize: theme.font.size14,
    backgroundImage: 'none',
    // "&:active": {
    //   background: theme.color.menu.homeSelected,
    // },
    padding: '0px 12px',
    display: 'flex',
    justifyContent: 'space-between',
  },
  dummyHomeIcon: {
    width: '24px',
    height: '24px',
  },
  homeIcon: {
    minWidth: '24px', // "24px",
    height: '24px', // "24px",
    backgroundSize: '24px', // "24px",
    backgroundImage: `url(${HomeIcon})`,
    // position: "absolute",
    right: '40px', // "40px"
  },
  // menuItem: {
  //   background: "#ffffff",
  //   border: "solid 1px #087e93",
  //   color: theme.color.menu.item,
  //   "&:active": {
  //     background: theme.color.menu.item,
  //     color: "#ffffff",
  //   },
  //   fontSize: theme.font.size14,
  //   whiteSpace: "normal",
  //   padding: "0px 12px"
  // },
  menuItem: {
    display: 'flex',
    width: '100%',
    height: '100%',
    border: '0px',
    flexDirection: 'column',
    alignItems: 'center',
    background: '#ffffff',
    cursor: 'pointer',
  },
  menuIconBack: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minWidth: '48px',
    minHeight: '48px',
    borderRadius: '50%',
    backgroundColor: '#f6f6f6',
    // "&:active": {
    //   background: theme.color.menu.item,
    //   color: "#ffffff",
    // },
  },
  menuIcon: {
    width: '24px',
    height: '24px',
  },
  menuStr: {
    minWidth: '60px',
    fontSize: theme.font.size11,
    color: theme.color.text_color.black,
    lineHeight: 1.18,
    letterSpacing: 'normal',
  },
});

function inputValidCheck(inputStr) {
  let result = true;
  if (inputStr.trim().length <= 0) {
    result = false;
  }
  return result;
}

let menuItems = [
  {
    title: '스스로해결/출장 예약',
    text: '스스로해결/출장 예약',
    parameters: {
      to: 'THQ_DIAGNOSIS',
    },
    type: 'bypass',
    icon: MenuGear,
  },
  {
    title: '서비스 예약 확인/변경',
    text: '서비스 예약 확인/변경',
    parameters: {
      to: 'THQ_BOOK_CHECK',
    },
    type: 'bypass',
    icon: MenuCalendar,
  },
  {
    title: '이전설치',
    text: '이전설치',
    parameters: {
      to: 'THQ_RELOCATE_BOOK',
    },
    type: 'bypass',
    icon: MenuInstall,
  },
  {
    title: '가전 세척 예약',
    text: '가전 세척 예약',
    parameters: {
      to: 'THQ_CLEAN_SERVICE',
    },
    type: 'bypass',
    icon: MenuWash,
  },
  {
    title: '제품 검색/구매',
    text: '제품 검색/구매',
    parameters: {
      to: 'THQ_PRODUCT_SEARCH',
    },
    type: 'bypass',
    icon: MenuSearch,
  },
  {
    title: '소모품 검색/구매',
    text: '소모품 검색/구매',
    parameters: {
      to: 'THQ_EXPENDABLES_PURCHASE',
    },
    type: 'bypass',
    icon: MenuTables,
  },
  {
    title: '구독 추천',
    text: '구독 추천',
    parameters: {
      to: 'THQ_SUBSCRIPTION_RECOMMEND',
    },
    type: 'bypass',
    icon: MenuRental,
  },
  {
    title: '구매전문가 상담',
    text: '구매전문가 상담',
    parameters: {
      to: 'THQ_PURCHASE_EXPERT_CHAT',
    },
    type: 'bypass',
    icon: MenuConsulting,
  },
  {
    title: '서비스센터 찾기',
    text: '서비스센터 찾기',
    parameters: {
      to: 'THQ_SERVICECENTER_LOCATION',
    },
    type: 'bypass',
    icon: MenuCenter,
  },
  {
    title: '베스트샵 찾기',
    text: '베스트샵 찾기',
    parameters: {
      to: 'THQ_BESTSHOP_LOCATION',
    },
    type: 'bypass',
    icon: MenuShop,
  },
  {
    title: '제품 사용가이드',
    text: '제품 사용가이드',
    parameters: {
      to: 'THQ_STORY_TYPE',
      story_type: 'esay_use',
    },
    type: 'bypass',
    icon: MenuGuide,
  },
  {
    title: '스토리 보기',
    text: '스토리 보기',
    parameters: {
      to: 'THQ_STORY_TYPE',
    },
    type: 'bypass',
    icon: MenuStory,
  },
  // {
  //   title: '제품 추천',
  //   text: '제품 추천',
  //   parameters: {
  //     to: 'THQ_PRODUCT_RECOMMEND',
  //     //      search_type: "lifestyle",
  //   },
  //   type: 'bypass',
  //   icon: MenuRecomProd,
  // },
  {
    title: '기획전/이벤트',
    text: '기획전/이벤트',
    parameters: {
      to: 'THQ_EVENT_SEARCH',
    },
    type: 'bypass',
    icon: MenuEvent,
  },
  {
    title: '로그인',
    text: '로그인',
    parameters: {
      to: 'THQ_LGE_ACCOUNT_LOGIN',
    },
    type: 'bypass',
    icon: MenuLogin,
  },
  {
    title: '이용약관',
    text: '이용약관',
    parameters: {
      to: 'THQ_FAQ_APP_001',
    },
    type: 'bypass',
    icon: MenuPolicy,
  },
];

// add aria label
menuItems = menuItems.map((item, index) => {
  return {
    ...item,
    aria: `${index + 1}/${menuItems.length}, 항목${menuItems.length}개`,
  };
});

const maxMenuItemForGroup = 8;
const menuItemsGroup = [];
for (let index = 0; index < menuItems.length; index += maxMenuItemForGroup) {
  menuItemsGroup.push(menuItems.slice(index, index + maxMenuItemForGroup));
}

const MenuGroup = React.forwardRef((props, ref) => {
  const { classes, parentFunc, activeSlide } = props;

  const handleMenuClick = (item) => {
    if (!ref.clickAllowed()) {
      return;
    }
    parentFunc.handleMenuClick(item);
  };
  return menuItemsGroup.map((menuItems, menuItemsIndex) => (
    <Grid
      key={`menuItemsGroupd-${menuItemsIndex}`}
      className={classes.menu}
      container
      spacing={1}
    >
      {menuItems.map((item, itemIndex) => (
        <Grid key={`menuItems-${itemIndex}`} item xs={3}>
          <button
            type="button"
            className={[/*classes.menus,*/ classes.menuItem].join(' ')}
            onClick={() => handleMenuClick(item)}
            aria-label={`${item.title}, ${item.aria}`}
            aria-hidden={activeSlide !== menuItemsIndex}
            tabIndex={activeSlide !== menuItemsIndex ? '-1' : ''}
          >
            <div className={classes.menuIconBack}>
              <img src={item.icon} className={classes.menuIcon} alt="" />
            </div>
            <p className={classes.menuStr}>{item.title}</p>
          </button>
        </Grid>
      ))}
    </Grid>
  ));
});

function Footer(props) {
  const { classes } = props;
  const data = useContext(DataContext);
  const input = useContext(InputContext);
  const inputRef = useRef(null);
  const [menu, setMenu] = useState(false);
  const [openCancelBtn, setOpenCancelBtn] = useState(false);
  const [inputFocused, setInputFocused] = useState(false);
  const [queryAutocomData, setQueryAutocomData] = useState(false);
  const [triggerTimer, setTriggerTimer] = useState(null);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (inputValidCheck(input)) {
      data.request(data, input, 'text');
      input.setInput(input);
    } else {
      console.log('input value is not valid');
    }

    if (triggerTimer) {
      console.log(`[handleSubmit] clearTimeout for queryAutocompleteParam`);
      clearTimeout(triggerTimer);
    }

    if (data.userAgent.deviceType === 'mobile') {
      // 모바일인 경우, 키보드 Focus 를 삭제하여 키보드를 내린다.
      inputRef.current.blur();
    } else {
      inputRef.current.focus();
    }
    input.keyboard.setOpen(false);
  };

  const makeACParameters = (data, isOpenStatus = false) => {
    let totalContents = 0;
    let paramContent = [];
    if (data.result.content) {
      paramContent = data.result.content.map((content, contentIndex) => {
        return {
          filter: 'content',
          category: content.product_name,
          data: content.content_title,
          speech: content.content_title,
          order: contentIndex + 1,
          orgData: content,
          useSpeech: false,
        };
      });
      totalContents = data.result.content.length;
    }
    let paramSymptom = [];
    if (data.result.symptom) {
      paramSymptom = data.result.symptom.map((symptom, symptomIndex) => {
        return {
          filter: 'symptom',
          category: symptom.product_name,
          data: symptom.sub2_symptom_name,
          speech: isOpenStatus ? symptom.product_symptom_name : symptom.sub2_symptom_name,
          order: totalContents + symptomIndex + 1,
          orgData: symptom,
          useSpeech: true,
        };
      });
      totalContents = totalContents + data.result.symptom.length;
    }
    let paramModel = [];
    if (data.result.model) {
      paramModel = data.result.model.map((model, modelIndex) => {
        return {
          filter: 'model',
          category: '모델명',
          data: model,
          speech: model,
          order: totalContents + modelIndex + 1,
          orgData: model,
          useSpeech: true,
        };
      });
    }
    return [...paramContent, ...paramSymptom, ...paramModel];
  };

  const searchACParameters = (context, text) => {
    // const searchTypeArray = ["content", "symptom", "model"];
    const searchTypeArray = input.autoComplete.parameters?.searchType
      ? input.autoComplete.parameters.searchType
      : ['symptom', 'model'];
    const productCode = input.autoComplete.parameters?.product_code;
    // const searchText =text.slice(0,acWordMax);
    const searchText = text;
    const highlight = true;
    let isOpenStatus = true;
    if (
      Array.isArray(input.autoComplete.parameters?.searchType) &&
      input.autoComplete.parameters.searchType.includes('symptom')
    ) {
      isOpenStatus = false;
    }

    chatAIAutocomplete(context, searchTypeArray, searchText, highlight, productCode)
      .then((data) => {
        console.log(data);
        if (input.autoComplete.enable) {
          const autocomParameters = makeACParameters(data, isOpenStatus);
          input.autoComplete.setEnable(true, {
            ...input.autoComplete.parameters,
            items: autocomParameters,
          });
          input.autoComplete.setOpen(true);
        } else {
          console.log(
            `[searchACParameters] input.autoComplete.enable - false - show nothing`
          );
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleChange = (e) => {
    e.preventDefault();
    const text =
      e.target.value.length > 256 ? e.target.value.substring(0, 256) : e.target.value;
    input.setInput(text);

    if (e.target.value.length > 0) {
      setOpenCancelBtn(true);
    } else {
      setOpenCancelBtn(false);
    }

    const acWordMax = 2;
    if (input.autoComplete.enable && e.target.value.length >= acWordMax) {
      if (triggerTimer) {
        console.log(`[queryAutocompleteParam] clearTimeout`);
        clearTimeout(triggerTimer);
      }
      const triggerWait = 500;
      console.log(`[queryAutocompleteParam] setTimeout (${triggerWait})msec`);
      const timeoutId = setTimeout(() => {
        searchACParameters(data, text);
      }, triggerWait);
      setTriggerTimer(timeoutId);
    }

    if (e.target.value.length < acWordMax) {
      if (triggerTimer) {
        console.log(`[queryAutocompleteParam] clearTimeout`);
        clearTimeout(triggerTimer);
      }
      input.autoComplete.setOpen(false);
    }
  };

  const handleSend = () => {
    if (inputValidCheck(input.input)) {
      data.request(data, input.input, 'text');
      input.setInput('');
    }
    // setTimeout(() => inputRef.current.focus(), 100);
    input.keyboard.setOpen(false);
    setOpenCancelBtn(false);

    input.autoComplete.setOpen(false);
    if (triggerTimer) {
      console.log(`[handleSend] clearTimeout for queryAutocompleteParam`);
      clearTimeout(triggerTimer);
    }
  };

  const handleCancel = () => {
    input.setInput('');
    setOpenCancelBtn(false);
  };

  const handleEnter = (e) => {
    if (
      e.keyCode === 13 &&
      e.shiftKey === false &&
      data.userAgent.deviceType !== 'mobile'
    ) {
      e.preventDefault();
      handleSend();
    }
  };

  const handleFocus = () => {
    if (
      input.autoComplete &&
      input.autoComplete.enable &&
      input.autoComplete.parameters &&
      !input.autoComplete.open
    ) {
      input.autoComplete.setOpen(true);
      input.keyboard.setOpen(true);
    } else if (!input.keyboard.open) {
      input.keyboard.setOpen(true);
    }

    // 채팅 내용이 긴 경우 딜레이를 500ms 로 증가 시킨다.
    data.scroll(false, data.isShowOldConversations ? 600 : 300);
    setMenu(false);
    setInputFocused(true);
  };

  const handleBlur = () => {
    setTimeout(() => setInputFocused(false), 100);
  };

  // const handleFocusOut = () => {
  //   if (
  //     input.autoComplete &&
  //     input.autoComplete.enable &&
  //     input.autoComplete.parameters &&
  //     !input.autoComplete.open &&
  //     input.input.length > 0
  //   ) {
  //     setTimeout(() => {
  //       input.autoComplete.setOpen(true);
  //     }, 200);
  //   } else if (input.autoComplete.open) {
  //     setTimeout(() => {
  //       input.autoComplete.setOpen(false);
  //       input.keyboard.setOpen(false);
  //     }, 200);
  //   }
  // };

  const handleKeyboardOpen = (open) => {
    if (input.keyboard.open && !open) {
      inputRef.current.blur();
      // input.autoComplete.setOpen(false);
    }
  };

  useEffect(() => {
    input.keyboard.handleOpen = handleKeyboardOpen;
    return () => {
      if (triggerTimer) {
        clearInterval(triggerTimer);
      }
    };
  }, []);

  const closeKeyboard = () => {
    if (input.keyboard.open) {
      input.keyboard.setOpen(false);
      console.log('close keyboard');
    } else if (
      input.autoComplete &&
      input.autoComplete.enable &&
      input.autoComplete.parameters &&
      input.autoComplete.open
    ) {
      input.autoComplete.setOpen(false);
    }
  };

  // Footer에서 스크롤 시 키보드 종료 이벤트를 설정한다.
  window.isTabed = false;
  window.addEventListener('touchstart', () => (window.isTabbed = true));
  window.addEventListener('touchend', () => (window.isTabbed = false));
  window.addEventListener('touchmove', () => {
    if (window.isTabbed) {
      closeKeyboard();
      window.isTabbed = false;
    }
  });

  const handleMenu = () => {
    if (input.keyboard.open) input.keyboard.setOpen(false);
    if (!menu) data.scroll(false, data.isShowOldConversations ? 600 : 300);
    setMenu(!menu);

    const autoCompleteContainer = document.getElementById('autoCompleteContainer');
    if (autoCompleteContainer) {
      !menu
        ? (autoCompleteContainer.style.bottom = '323.88px')
        : (autoCompleteContainer.style.bottom = '54px');
    }
  };

  const handleMenuClick = (item) => {
    if (item?.type === 'bypass') {
      data.request(data, item.text, 'button', item.parameters, {
        mode: 'bypass',
        intent: 'DIRECT_MESSAGE',
      });
    } else {
      data.request(data, item.text, 'button');
    }
    setMenu(false);
  };

  const parentFunc = {
    handleMenuClick,
  };

  return (
    <div className={classes.root}>
      <div className={classes.row}>
        {/* <button
          className={[classes.button, classes.home].join(" ")}
          disabled={data.conversationEnd || !data.conversationStart}
          onClick={handleHome}
          aria-label={data.string.aria.footer.restart}
        /> */}
        <button
          type="button"
          className={[
            classes.button,
            menu ? classes.menuClose : classes.menuButton,
            (data.conversationEnd || !data.conversationStart) && classes.menuDisabled,
          ].join(' ')}
          disabled={data.conversationEnd || !data.conversationStart}
          onClick={handleMenu}
          aria-label={
            menu ? data.string.aria.footer.menuClose : data.string.aria.footer.menuOpen
          }
        />
        <div className={classes.formContainer}>
          <form className={classes.form} onSubmit={handleSubmit}>
            <label htmlFor="TextareaAutosize" id="autocomplete_label" hidden>
              입력 예시 표시됨.
            </label>
            <TextareaAutosize
              title={data.conversationEnd ? '' : data.string.chat.inputHint}
              id="TextareaAutosize"
              className={classes.input}
              ref={inputRef}
              type="text"
              value={data.conversationEnd ? '' : input.input}
              onSubmit={handleSubmit}
              onChange={handleChange}
              onKeyDown={handleEnter}
              onFocus={handleFocus}
              onBlur={handleBlur}
              // onBlur={handleFocusOut}
              disabled={data.conversationEnd || !data.conversationStart}
              placeholder={data.conversationEnd ? '' : data.string.chat.inputHint}
              maxRows={2}
              aria-labelledby={input.autoComplete.open && 'autocomplete_label'}
            />
          </form>

          {openCancelBtn && (
            <button
              type="button"
              className={classes.cancel}
              onClick={handleCancel}
              disabled={data.conversationEnd}
              aria-label="입력삭제"
            >
              <div
                className={[
                  classes.cancelImage,
                  // data.conversationEnd ? classes.sendImageDisabled : "",
                ].join(' ')}
              />
            </button>
          )}

          <button
            type="button"
            className={classes.send}
            onClick={handleSend}
            disabled={data.conversationEnd || !inputFocused}
            aria-label={data.string.aria.footer.sendUserInput}
          >
            <div
              className={[
                classes.sendImage,
                inputFocused ? classes.sendImageFocused : classes.sendImageNotFocused,
                data.conversationEnd ? classes.sendImageDisabled : '',
              ].join(' ')}
            />
          </button>
        </div>
        {/* <button
          className={[classes.test, record ? classes.recording : ""].join(" ")} 
          onClick={handleSend} 
          disabled={data.conversationEnd}
        /> */}

        {/* <button
          className={[
            classes.button,
            data.conversationEnd ? classes.sendDisabled : classes.send,
          ].join(" ")}
          disabled={data.conversationEnd}
          onClick={handleSend}
          aria-label={data.string.aria.footer.sendUserInput}
        /> */}

        {(data.conversationEnd ||
          data.zendeskPaused ||
          (data.zendeskEnabled && !data.zendeskConnected)) && (
          <div className={classes.rowDisable} role={'status'}>
            {!data.zendeskPaused &&
              !(data.zendeskEnabled && !data.zendeskConnected) &&
              data.string.chat.conversationEnd}
          </div>
        )}
      </div>

      {menu &&
        !data.conversationEnd &&
        (menuItemsGroup.length > 1 ? (
          <Carousel component={withStyles(styles)(MenuGroup)} parentFunc={parentFunc} />
        ) : (
          <Grid className={classes.menu} container spacing={1}>
            {menuItems.map((item) => (
              <Grid item xs={3}>
                <button
                  type="button"
                  className={[/*classes.menus,*/ classes.menuItem].join(' ')}
                  onClick={() => handleMenuClick(item)}
                  aria-label={`${item.title}, ${item.aria}`}
                >
                  <div className={classes.menuIconBack}>
                    <img src={item.icon} className={classes.menuIcon} />
                  </div>
                  <p className={classes.menuStr}>{item.title}</p>
                </button>
              </Grid>
            ))}
          </Grid>
        ))}
    </div>
  );
}
export default withStyles(styles)(Footer);
